export default __webpack_public_path__ + "static/media/immaculateheartofmary.c22d8905.jpg";